import { render, staticRenderFns } from "./AddCompanyUserRoleDialog.vue?vue&type=template&id=4c61ca56"
import script from "./AddCompanyUserRoleDialog.vue?vue&type=script&lang=ts"
export * from "./AddCompanyUserRoleDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports